import {
  BottomSheet,
  Illustration,
  Text,
  TextButton,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { UPDATE_EMAIL_FULL_PATH } from "@src/appV2/redesign/Profile/paths";

import { ButtonInternalLink } from "../../components/ButtonInternalLink";
import { type PlacementCandidateScreeningStatus } from "../../PlacementCandidate/types";

interface EmailUsResumeConfirmationDialogProps {
  modalState: UseModalState;
  workerEmail: string;
  placementCandidateId: string;
  candidateScreeningStatus?: PlacementCandidateScreeningStatus;
  placementId: string;
  workplaceId: string;
}

export function EmailUsResumeConfirmationDialog(props: EmailUsResumeConfirmationDialogProps) {
  const {
    modalState,
    workerEmail,
    placementCandidateId,
    candidateScreeningStatus,
    placementId,
    workplaceId,
  } = props;

  const logContext = {
    placementCandidateId,
    candidateScreeningStatus,
    placementId,
    workplaceId,
  };

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={handleClose} />}
      footer={
        <DialogFooter orientation="horizontal" sx={{ px: 8, pb: 8, pt: 2 }}>
          <Stack spacing={6} width="100%" alignItems="center">
            <Text variant="body2">If you don&apos;t see it, please check your spam folder.</Text>
            <LoadingButton
              fullWidth
              variant="contained"
              size="large"
              isLoading={false}
              onClick={() => {
                modalState.closeModal();
                logEvent(APP_V2_APP_EVENTS.PLACEMENT_EMAIL_RESUME_CONFRIMATION_DIALOG_ACTIONS, {
                  action: "confirm",
                  ...logContext,
                });
              }}
            >
              Confirm
            </LoadingButton>
            <TextButton
              underline
              LinkComponent={ButtonInternalLink}
              size="large"
              href={UPDATE_EMAIL_FULL_PATH}
              onClick={() => {
                logEvent(APP_V2_APP_EVENTS.PLACEMENT_EMAIL_RESUME_CONFRIMATION_DIALOG_ACTIONS, {
                  action: "upload-email",
                  ...logContext,
                });
              }}
            >
              Update your email address
            </TextButton>
          </Stack>
        </DialogFooter>
      }
    >
      <Stack
        spacing={8}
        alignItems="center"
        justifyContent="center"
        sx={{ paddingX: 4, paddingTop: 6, paddingBottom: 10 }}
      >
        <Illustration type="request-sent" />
        <Stack spacing={6} textAlign="center">
          <Text variant="h2">Check your email!</Text>
          <Text>
            We&apos;ve just sent an email to{" "}
            <Box component="span" sx={{ textDecoration: "underline" }}>
              {workerEmail}
            </Box>{" "}
            from{" "}
            <Box component="span" sx={{ textDecoration: "underline" }}>
              documents@cbhjobs.com
            </Box>
          </Text>
        </Stack>
      </Stack>
    </BottomSheet>
  );
}
